import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import PasswordInput from './PasswordInput';
import logoActivus from '../assets/ActivusSoftware.svg';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch {
      setError('Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src={logoActivus} alt="Activus Group" style={styles.logo} />
        <h1 style={styles.title}>License Monitor</h1>
        <p style={styles.subtitle}>Administration</p>
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            placeholder="Utilisateur"
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
            required
          />
          <PasswordInput
            style={{ ...styles.input, marginBottom: 0 }}
            wrapperStyle={{ marginBottom: '1rem' }}
            placeholder="Mot de passe"
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

// Charte Activus Group : bleu nuit #232853, fond clair, texte #444.
const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' },
  card: { background: '#ffffff', padding: '2.5rem', borderRadius: '12px', width: '360px', maxWidth: 'calc(100vw - 2rem)', boxSizing: 'border-box', boxShadow: '0 12px 40px rgba(0,0,0,0.12)', border: '1px solid #e6e6e6' },
  logo: { display: 'block', width: '220px', maxWidth: '100%', margin: '0 auto 1.25rem' },
  title: { color: '#232853', margin: '0 0 4px', fontSize: '1.35rem', textAlign: 'center' },
  subtitle: { color: '#6b7280', textAlign: 'center', marginBottom: '2rem' },
  input: { width: '100%', padding: '0.75rem', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #cdcdcd', background: '#f5f5f5', color: '#444444', fontSize: '0.95rem', boxSizing: 'border-box' },
  error: { color: '#c62828', fontSize: '0.875rem', marginBottom: '0.75rem' },
  btn: { width: '100%', padding: '0.75rem', background: '#232853', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '1rem', cursor: 'pointer', fontWeight: 600 },
};
